module.exports = __webpack_public_path__ + "static/media/mensajes-masivos-icon.c03ed683.svg";